// utils/callNote.js
//
// Construction du texte de note d'un « bilan d'appel » saisi dans la
// modale « Terminer l'appel » (AgentSession). Extrait ici en fonction
// pure pour être testable sans monter tout AgentSession.
//
// Contexte : la clôture d'appel enregistre désormais une INTERACTION
// (POST /api/agent/leads/:id/interactions, type 'note') plutôt qu'un
// changement de statut détourné — l'ancien flux passait la note dans le
// champ `raison` d'UpdateLeadStatus, qui l'ignore totalement, et tentait
// une transition `nouveau → qualifié` refusée par la machine à états
// (perte systématique des notes d'appel + 400 avalés en silence).

/** Libellés lisibles des propositions commerciales (pour la note). */
export const PROPOSITION_LABELS = {
  energie: 'Énergie',
  assurance: 'Assurance',
  senior_plus: 'Senior-Plus',
};

/**
 * Construit le texte de note d'un bilan d'appel à partir des champs de la
 * modale. Renvoie '' si rien d'exploitable n'a été saisi (ni note, ni
 * durée valide, ni proposition) — l'appelant peut alors éviter de créer
 * une interaction vide (le domaine `Interaction` refuse une note vide).
 *
 * Ordre des segments : note libre → durée → propositions, joints par « — ».
 *
 * @param {{ notes?: string, duree_min?: number|null,
 *           propositions?: Record<string,string> }} [fields]
 * @returns {string}
 */
export function buildCloseCallNote({ notes, duree_min, propositions } = {}) {
  const proposed = Object.entries(propositions || {})
    .filter(([, v]) => v === 'propose')
    .map(([k]) => PROPOSITION_LABELS[k] || k);

  return [
    notes && notes.trim(),
    Number.isFinite(duree_min) && duree_min > 0 ? `Durée : ${duree_min} min` : null,
    proposed.length ? `Proposé : ${proposed.join(' · ')}` : null,
  ]
    .filter(Boolean)
    .join(' — ');
}
